module.exports = __webpack_public_path__ + "img/whatsappBlack.c5dcbf99.gif";